import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { adminApi, tokenStore } from '../lib/api';

export function LoginPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState<'email' | 'token'>('email');
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [totp, setTotp] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  async function requestLink(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await adminApi.requestMagicLink(email);
      setSent(true);
      setStep('token');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to send link');
    } finally {
      setBusy(false);
    }
  }

  async function verify(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await adminApi.verifyMagicLink(token, totp || undefined);
      await tokenStore.set({
        accessToken: res.accessToken,
        refreshToken: res.refreshToken,
        expiresAt: Date.now() + res.expiresIn * 1000,
      });
      navigate({ to: '/' });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Verification failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="h-screen flex items-center justify-center" style={{ background: 'var(--bg)' }}>
      <div className="card w-full max-w-sm p-6">
        <div className="font-display text-2xl mb-1" style={{ color: 'var(--brand-dark)' }}>wheez</div>
        <div className="text-sm mb-5" style={{ color: 'var(--text-faint)' }}>Admin console</div>

        {step === 'email' ? (
          <form onSubmit={requestLink} className="space-y-3">
            <label className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>Work email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full" placeholder="you@wheez.ng" />
            <button type="submit" disabled={busy} className="btn-accent w-full">{busy ? 'Sending…' : 'Send sign-in link'}</button>
          </form>
        ) : (
          <form onSubmit={verify} className="space-y-3">
            {sent && <p className="text-xs" style={{ color: 'var(--success)' }}>Link sent. Paste the token from the email (or dev shortcut) below.</p>}
            <label className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>Link token</label>
            <input required value={token} onChange={(e) => setToken(e.target.value)} className="w-full" placeholder="Paste token" />
            <label className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>Authenticator code (if enrolled)</label>
            <input value={totp} onChange={(e) => setTotp(e.target.value)} className="w-full" placeholder="123456" />
            <button type="submit" disabled={busy} className="btn-accent w-full">{busy ? 'Verifying…' : 'Sign in'}</button>
          </form>
        )}
        {error && <p className="text-xs mt-3" style={{ color: 'var(--danger)' }}>{error}</p>}
      </div>
    </div>
  );
}
